import React from "react";

export default function ImpactLevel({ hoverModalDisplay }) {
  return (<div id="fedramp-impactLevelBox" className={`fedramp-impactLevelBoxClass fedramp-hoverBox${hoverModalDisplay}`}>
    <strong>Impact Level:</strong>
    <br/><br/>
    The security level for the cloud service offering.
    Can be:<br/>
    <ul>
      <li>Low</li>
      <li>Low-Impact Software-as-a-Service (LI-SaaS)</li>
      <li>Moderate</li>
      <li>High</li>
    </ul>
  </div>);
}